// extracted by mini-css-extract-plugin
export var banner = "_h4-0";
export var closeButton = "_h4-2";
export var greenCheckmark = "_h4-3";
export var hereLink = "_h4-4";
export var titleIcon = "_h4-1";